export const COUNTRY_GET_ALL_SUCCESS = 'COUNTRY_GET_ALL_SUCCESS';
export const COUNTRY_GET_ALL_FAILURE = 'COUNTRY_GET_ALL_FAILURE';
export const COUNTRY_DATA_IS_LOADING = 'COUNTRY_DATA_IS_LOADING';

export const COUNTRY_TABLE_GET_ALL_SUCCESS = 'COUNTRY_TABLE_GET_ALL_SUCCESS';
export const COUNTRY_TABLE_GET_ALL_FAILURE = 'COUNTRY_TABLE_GET_ALL_FAILURE';
export const COUNTRY_TABLE_DATA_IS_LOADING = 'COUNTRY_TABLE_DATA_IS_LOADING';

